import { makeStyles } from 'tss-react/mui';

export const COLLAPSED_WIDTH = 56;
export const EXPANDED_WIDTH = 240;

const LOGO_HEIGHT = 26;
const LOGO_COLLAPSED_WIDTH = 26;
const LOGO_EXPANDED_WIDTH = 110;

export const useStyles = makeStyles()((theme) => ({
    drawer: {
        width: COLLAPSED_WIDTH,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
    },
    drawerCollapsed: {
        '& .MuiDrawer-paper': {
            width: COLLAPSED_WIDTH,
            overflowX: 'hidden',
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
    },
    drawerExpanded: {
        '& .MuiDrawer-paper': {
            width: EXPANDED_WIDTH,
            overflowX: 'hidden',
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxShadow: theme.shadows[8],
        },
    },
    drawerPaper: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#1d1f23',
        color: theme.palette.common.white,
        borderRight: 'none',
        zIndex: theme.zIndex.drawer + 1,
        '& .MuiListItemIcon-root': {
            color: 'rgba(255, 255, 255, 0.7)',
        },
        '& .MuiListItemButton-root:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
        },
        '& .MuiListItemButton-root.Mui-selected': {
            backgroundColor: 'rgba(250, 53, 146, 0.16)',
        },
        '& .MuiListItemButton-root.Mui-selected:hover': {
            backgroundColor: 'rgba(250, 53, 146, 0.24)',
        },
        '& .MuiDivider-root': {
            borderColor: 'rgba(255, 255, 255, 0.12)',
        },
    },
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
        height: 64,
        padding: theme.spacing(0, 1.75),
        flexShrink: 0,
    },
    logoReveal: {
        height: LOGO_HEIGHT,
        flexShrink: 0,
        objectFit: 'cover',
        objectPosition: 'left center',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    logoRevealCollapsed: {
        width: LOGO_COLLAPSED_WIDTH,
    },
    logoRevealExpanded: {
        width: LOGO_EXPANDED_WIDTH,
    },
    navList: {
        flex: 1,
        padding: theme.spacing(1, 0),
    },
    footer: {
        marginTop: 'auto',
        borderTop: '1px solid rgba(255, 255, 255, 0.12)',
        padding: theme.spacing(1, 0),
    },
}));
